import { render, staticRenderFns } from "./customRefHouse.vue?vue&type=template&id=b17563b0&"
import script from "./customRefHouse.vue?vue&type=script&lang=js&"
export * from "./customRefHouse.vue?vue&type=script&lang=js&"
import style0 from "./customRefHouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b17563b0', component.options)
    } else {
      api.reload('b17563b0', component.options)
    }
    module.hot.accept("./customRefHouse.vue?vue&type=template&id=b17563b0&", function () {
      api.rerender('b17563b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/customRefHouse.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/customRefHouse.vue
// module id = 466
// module chunks = 0